module.exports = __webpack_public_path__ + "static/bluewhale1-4209c16edba41abe99f1d97762824b83.png";